// 1
import { commitMutation } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import environment from "../environment/index.js";

// 2
// deleteCoverpage(id: ID!): Response
const mutation = graphql`
  mutation DeleteMicrositeMutation($deleteMicrositeId: ID!) {
    deleteMicrosite(id: $deleteMicrositeId) {
      ... on Microsite {
        _id
        id
        portalId
      }
      ... on Response {
        message
        status
        success
        token
        hash
        userId
        __typename
      }
    }
  }
`;

export default (deleteMicrositeId, callback) => {
  // 4
  const variables = {
    deleteMicrositeId,
  };

  // 5
  commitMutation(environment, {
    mutation,
    variables,
    // 6
    onCompleted: response => {
      callback(response);
    },
    onError: err => callback(err),
    updater: store => {
      // Temporary Acces to Store In Consol for testing.
      window.store = store;
    },
  });
}; // 3
